<script setup>
/** 一条对局记录的正文：玩家输入、旁白、NPC 台词。回放和分镜卡的来源列共用。 */
import { useI18n } from 'vue-i18n'

defineProps({
  entry: { type: Object, required: true },
})

const { t } = useI18n()
</script>

<template>
  <p v-if="entry.player_input" class="beat-text__line is-input">
    <span class="beat-text__tag">{{ t('visualGameAdmin.generationRecords.process.transcript.player') }}</span>{{ entry.player_input }}
  </p>
  <p v-if="entry.narration" class="beat-text__line">{{ entry.narration }}</p>
  <p v-if="entry.npc_line" class="beat-text__line">
    <span class="beat-text__tag">{{ t('visualGameAdmin.generationRecords.process.transcript.npc') }}</span>{{ entry.npc_line }}
  </p>
</template>

<style scoped>
.beat-text__line {
  margin: 0;
  line-height: 1.6;
  word-break: break-word;
}

.beat-text__line.is-input {
  font-weight: var(--drama-font-weight-medium);
}

.beat-text__tag {
  display: inline-block;
  margin-right: var(--drama-space-sm);
  padding: 0 var(--drama-space-xs);
  border-radius: var(--drama-radius-sm);
  background: var(--drama-color-surface-alt);
  color: var(--drama-color-text-muted);
  font-size: var(--drama-font-size-xs);
  font-weight: var(--drama-font-weight-regular);
}
</style>
